module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2737cd28da062447446bc93240e17270.png";